import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Fisico } from '../fisico';
import { InventariofisicoService } from '../inventariofisico.service';
import { ProductoService } from '../producto.service';
import { Producto } from '../producto';
import * as XLSX from 'xlsx';  
import { truncate } from 'fs';
@Component({
  selector: 'app-iventario-fisico',
  templateUrl: './iventario-fisico.component.html',
  styleUrls: ['./iventario-fisico.component.css']
})
export class IventarioFisicoComponent implements OnInit {
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  previous: any = [];
  fecha: string;
  fileName= 'InventarioFisico.xlsx';  

fisicos: Fisico[] = [];
  productos: Producto[];
  estado:string
  desabilitar:boolean
  constructor( private apiProducto: ProductoService, private datePipe: DatePipe,private alertService: AlertService,private api: InventariofisicoService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }


  onChange(newValue) {
    if (newValue === 'I') {
      this.desabilitar =false;
    } else {
      this.desabilitar =true;
    }
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.fisicos = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.fisicos = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  ngOnInit(): void {
 
    this.listarInventario();
    this.listar();
   
  }

  guardar(){
    this.fisicos = this.mdbTable.getDataSource();
    this.api.setActulizar(this.fisicos).
    subscribe(

      data  => {
        this.alertService.success("Se actulizo con exito");
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  
  
  }


  procesarInventario(){
    if(confirm("Está seguro de cargar el Inventario..? ")) {
    this.fisicos = this.mdbTable.getDataSource();
    this.api.procesarInventario(this.fisicos).
    subscribe(

      data  => {
        this.alertService.success("Se actulizo con exito");
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
    }
  
  }

  eliminar(id: number){
    if(confirm("Está seguro de eliminar ")) {
  
    this.api.eliminar(id).
    subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
        this.listar();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  
  }
}


listarInventario(){
  this.apiProducto.getProductoInventario(localStorage.getItem('id'))
    .subscribe((
      data: Producto[]) => {
      this.productos = data;
     

      }, err => {
        console.log(err);
       
      });

}


listar(){
 
  this.api.getListar(this.datePipe.transform(this.fecha, "dd-MM-yyyy"),localStorage.getItem('id'),this.estado)
.subscribe((
    data: Fisico[]) => {
    this.fisicos = data;
    this.fisicos.forEach(element => {
      let prodocto= this.productos.find(a=>a.codigo==element.idProducto)
      if (this.estado!=='P'){
          element.stock=prodocto.stock
      }
          element.diferencia=element.cantidad-element.stock
          element.codigo=prodocto.codigoPrincipal
          element.costo=prodocto.costo
          if (element.diferencia<0){
            element.estadoPagina='FALTANTE'
              element.color="yellow"
          }
          if (element.diferencia>0){
              element.estadoPagina='SOBRANTE'
                element.color="red"
          }
    });
    console.log(this.fisicos);
    this.mdbTable.setDataSource(this.fisicos);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.alertService.danger("Error en servicios...");
    });

}



exportexcel() 
{
   /* table id is passed over here */   
   const element = document.getElementById('mdbTable'); 
   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

   /* generate workbook and add the worksheet */
   const wb: XLSX.WorkBook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

   /* save to file */
   XLSX.writeFile(wb, this.fileName);
  
}


}
